import { ChangeEvent, forwardRef, useState } from 'react';
import { Input } from '@components/input';
import { electronicFormatIBAN } from 'ibantools';

import { InputBankNumberProps } from './input-bank-number.type';

export const InputBankNumber = forwardRef<HTMLInputElement, InputBankNumberProps>(
  ({ hasError, onChange, value = '', type, formatOnBlur = true, id, name, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState<string | undefined>(value);

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const val = e.target.value;
      setInternalValue(val);

      if (onChange) {
        onChange(e);
      }
    };

    const handleBlur = () => {
      if (formatOnBlur && type === 'iban' && internalValue) {
        const formatted = electronicFormatIBAN(internalValue);
        setInternalValue(formatted ?? undefined);

        const syntheticEvent = {
          target: { value: formatted, name },
        } as ChangeEvent<HTMLInputElement>;

        if (onChange) {
          onChange(syntheticEvent);
        }
      }
    };

    return (
      <div>
        <Input
          ref={ref}
          id={id}
          name={name}
          value={internalValue}
          onChange={handleChange}
          onBlur={handleBlur}
          hasError={hasError}
          {...props}
        />
      </div>
    );
  }
);
